import React, { FC, useState, useEffect } from 'react';
import styles from './innerheader.module.css';
import './header-bugger.scss';
import { NavLink } from 'react-router-dom';
import { Menu } from '../Menu';
import { useLocation } from 'react-router-dom';
// import { getAnalytics, logEvent } from 'firebase/analytics';

const mainDomain =
  process.env.REACT_APP_GROUP_URL || 'https://www.ohyagroup.com';

export const InnerPageHeader: FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  // const analytics = getAnalytics();

  // useEffect(() => {
  //   let timer: NodeJS.Timeout | undefined;

  //   if (menuOpen) {
  //     timer = setTimeout(() => {
  //       logEvent(analytics, 'home_menu_time_stay', { time_length: true });
  //     }, 5000);
  //   }

  //   return () => {
  //     if (timer) {
  //       clearTimeout(timer);
  //     }
  //   };
  // }, [menuOpen, analytics]);

  useEffect(() => {
    if (!menuOpen) {
      setMenuOpen(false);
    }
  }, [location]);

  const handleToggle = () => {
    setMenuOpen(prev => !prev);
  };
  return (
    <>
      <div className={`max-w-[1920px] mx-auto ${styles.frame} z-10 bugger`}>
        <div className={styles.img}>
          <input
            type="checkbox"
            id="menuToggle"
            onChange={handleToggle}
          ></input>

          <label htmlFor="menuToggle" className="menuOpen">
            <div className="open"></div>
          </label>
          <div className="menu menuEffects">
            <label htmlFor="menuToggle"></label>
            <Menu />
          </div>
        </div>
        <NavLink to={mainDomain + '/'}>
          <img
            className={styles.logo}
            alt="Element"
            src="/assets/images/pages/2-5-3-4.svg"
          />
        </NavLink>
        <div className={styles.img} />
        {/* <img
          className={styles.img}
          alt="Account circle"
          src="/assets/images/home/account-circle-dark.png"
        /> */}
      </div>
    </>
  );
};
